<script lang="ts">
  type Variant =
    | 'primary'
    | 'secondary'
    | 'highlightRed'
    | 'highlightBlue'
    | 'highlightGreen'
    | 'outlineRed';
  type Size = 'normal' | 'small' | 'extra-small';

  export let variant: Variant = 'secondary';
  export let size: Size = 'normal';
  export let disabled = false;
  export let title: string | undefined = undefined;
  export let type: 'button' | 'reset' | 'submit' = 'button';
  let className: string | undefined = undefined;
  export let dataTestid: string | undefined = undefined;
  export { className as class };
</script>

<button
  class="button {variant} {size} {className}"
  {disabled}
  {title}
  {type}
  data-testid={dataTestid}
  on:click
>
  <slot />
</button>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';
  @use '../styles/font-sizes';

  .button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: spacing.$xxs spacing.$m;
    font-weight: 700;
    font-size: font-sizes.$text-s;
    font-variant-numeric: lining-nums;
    line-height: 2;
    color: colors.$black90;
    fill: colors.$black90;
    border: 2px solid transparent;
    border-radius: 4px;
    cursor: pointer;
    text-decoration-line: none;

    &:hover,
    &:focus {
      border-color: colors.$black90;
    }

    &:focus {
      box-shadow: 0 0 0 2px colors.$black30, 0 0 0 5px colors.$black10;
      outline: none;
    }

    &:disabled {
      cursor: not-allowed;
      color: colors.$black40;
      border-color: transparent;
    }
  }

  .highlightRed {
    background-color: colors.$colorOfTheYear2023;
    color: colors.$white100;

    &:disabled {
      background-color: lighten(colors.$colorOfTheYear2023, 10%);
    }
  }

  .outlineRed {
    border-color: colors.$colorOfTheYear2023;
    color: colors.$colorOfTheYear2023;

    &:hover,
    &:focus {
      background-color: colors.$colorOfTheYear2023;
      border-color: colors.$colorOfTheYear2023;
      color: white;
    }
  }

  .highlightBlue {
    background-color: colors.$highlightBlue;
    color: colors.$white100;

    &:disabled {
      background-color: colors.$primaryLight;
    }
  }

  .highlightGreen {
    background-color: colors.$highlightGreen;
    color: colors.$white100;

    &:disabled {
      background-color: lighten(colors.$highlightGreen, 10%);
    }
  }

  .primary {
    background-color: colors.$primary;
    color: colors.$greyLight;

    &:hover {
      background-color: colors.$primaryDark;
      border-color: colors.$primaryDark;
    }

    &:disabled {
      background-color: colors.$primaryLight;
    }

    &:active:not(:disabled) {
      background-color: colors.$primaryDark;
    }
  }

  .secondary {
    background-color: colors.$white100;
    border-color: colors.$black40;

    &:active:not(:disabled) {
      border-color: colors.$black90;
    }
  }

  .small {
    font-size: font-sizes.$text-xs;
    padding: spacing.$xxs spacing.$s;
  }

  .extra-small {
    font-size: font-sizes.$text-xxs;
    padding: spacing.$xxxs spacing.$xs;
  }
</style>
